import { makeStyles } from '@material-ui/core';

import { Tag, TagGroup } from '@backstage/ui';

const useStyles = makeStyles({
  container: {
    alignItems: 'center',
    padding: 'var(--bui-space-2) 0',
    display: 'flex',
    gap: 'var(--bui-space-2)',
  },
});

export interface ActivityLabelItemProps {
  text: string;
  tagLabel: string;
  ariaLabel?: string;
}

export const ActivityLabelItem = ({
  text,
  tagLabel,
  ariaLabel,
}: ActivityLabelItemProps) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <span>{text}</span>
      <TagGroup aria-label={ariaLabel}>
        <Tag size="small">{tagLabel}</Tag>
      </TagGroup>
    </div>
  );
};
